import type { ISVG } from './index';

/** Two markers diverging on one track — the reconciliation "divergence" motif. Sidebar nav icon. */
export const ResultAuditSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '20'}
		height={height || '20'}
		viewBox='0 0 24 24'
		fill='none'
	>
		{/* Comparison track */}
		<path
			d='M4 12h16'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
		/>
		{/* Source A marker (filled) */}
		<circle
			cx='8'
			cy='12'
			r='2.4'
			fill={color || 'currentColor'}
		/>
		{/* Source B marker (hollow) — offset = the divergence */}
		<circle
			cx='16'
			cy='12'
			r='2.4'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			fill='none'
		/>
		{/* The gap between them */}
		<path
			d='M10.6 12h2.8'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeDasharray='0.5 2.2'
		/>
		{/* Tick posts anchoring the track */}
		<path
			d='M4 9v6M20 9v6'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
		/>
	</svg>
);
